<template>
	<div>
		<div v-if="containers.length > 0" id="move-container-list">
			<b-table striped hover selected-variant="success" selectable select-mode="single" sticky-header="true" small :fields="fields"
					 :items="containers"
					 @row-selected="onRowSelected" responsive="sm">
				<template v-slot:cell(job_id)="data">
					{{ data.item.fieldData['Job ID'] }}
				</template>
				<template v-slot:cell(id)="data">
					{{ data.item.fieldData['Container_PK_ID'] }}
				</template>
				<template v-slot:cell(name)="data">
					{{ data.item.fieldData['Container Name'] }}
				</template>
				<template v-slot:cell(expiration)="data">
					{{ data.item.fieldData['Registration::Expiration Date'] }}
				</template>
			</b-table>
		</div>
		<div v-else>
			<span>There are no more containers in this job</span>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import feedbackMixin from "../../mixins/feedback";
import {EventBus} from "../../event-bus";

export default {
	name: 'MoveContainerList',
	mixins: [feedbackMixin],
	data() {
		return {
			fields: [
				{key: 'id', label: 'ID'},
				{key: 'job_id', label: 'Job ID'},
				{key: 'expiration', label: 'Expiration'},
				{key: 'name', label: 'Name'},
			],
			containers: []
		}
	},
	methods: {
		getMatchingContainers(jobId, containerId) {
			let currentDate = moment().format('MM/DD/YYYY');

			this.axios('/3ds/api/containers/search', {
				method: 'post',
				headers: {
					'Authorization': 'Bearer ' + this.token
				},
				data: {
					requests: [
						{
							criteria: {
								'Job ID': jobId,
								'Locked Container': 'No'
							}
						},
						{
							omit: true,
							criteria: {
								'Container_PK_ID': containerId
							}
						}
					]
				}
			})
				.then(value => {
					console.log(JSON.stringify(value));
					this.containers = value.data.data
				})
		},
		onRowSelected(rows) {
			//Since select-mode is 'single,' we get first and only row
			if (rows.length > 0) {
				let row = rows[0];
				console.log("Container ID " + row.fieldData['Container_PK_ID']);
				EventBus.$emit('container-selected', {
					container_id: row.fieldData['Container_PK_ID']
				})
			} else {
				EventBus.$emit('container-selected', {
					container_id: ''
				})
			}
		}
	},
	mounted() {
		this.getMatchingContainers(this.jobId, this.containerId)
	},
	props: {
		jobId: {
			type: String
		},
		containerId: {
			type: String
		}
	},
}
</script>

<style scoped>
#move-container-list >>> .table-hover tbody tr:hover {
    background-color: rgba(184, 218, 255, 0.5);
}

#move-container-list >>> .table-success {
    background-color: rgb(131, 186, 35);
}
</style>